<template lang="pug">
.dados-relatorio-rastreabilidade
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportData') }}
    .row.m-0
        .dados-relatorio-form
            el-form(ref="dadosRelatorioForm", :model="dadosRelatorio", :inline="true", label-position="top", class="form-alignment")
                .numero-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber') }}
                        span.required *
                    el-form-item(prop="reportNumber")
                        el-input(
                            v-model='dadosRelatorio.reportNumber',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber')"
                            type='number'
                            maxlength='250'
                            disabled
                        )

                .cultura
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.crop') }}
                        span.required *
                    el-form-item(prop="culture")
                        el-select(
                            v-model='dadosRelatorio.culture',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            value-key='id',
                            class="custom-select-cultura"
                            disabled
                        )
                            el-option(
                                v-for='cultura in culturas',
                                :key='cultura.id',
                                :value='cultura',
                                :label='cultura.nome'
                            ) {{ cultura.nome }}

                .volume
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume') }}
                        span.required *
                    el-form-item(prop="reportVolume")
                        el-input(
                            v-model='dadosRelatorio.reportVolume',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume')",
                            type='number',
                            @input='emitVolume',
                            disabled
                        )

                .data-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportDate') }}
                        span.required *
                    el-form-item(prop="reportDate")
                        el-date-picker(
                            v-model='dadosRelatorio.reportDate',
                            class='custom-date-picker',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                            disabled
                        )
</template>

<script>
import EventBus from '@/utils/eventBus';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import culturaService from '@/services/CulturaService';

export default {
    name: 'ReportDataDefault',
    data() {
        return {
            totalizerValues: [],
            volumeDisponivel: null,
            dadosRelatorio: {
                reportNumber: null,
                culture: null,
                reportVolume: null,
                reportDate: null
            },
            culturas: []
        };
    },
    watch: {
        dadosRelatorio: {
            handler(newVal) {
                EventBus.$emit('report-valid-data', newVal);
            },
            deep: true
        }
    },
    async mounted() {
        EventBus.$on('totalizer-updated', this.passDataToContractList);
        const params = this.$route.params;
        const response = await RelatorioRastreabilidadeService.findById(params.id);
        this.dadosRelatorio = response.data;
        this.emitVolume();
        this.buscaCulturas();
    },
    methods: {
        passDataToContractList(data) {
            this.totalizerValues = data;
            this.volumeDisponivel = data[1];
        },
        emitVolume() {
            EventBus.$emit('volume-input-updated', this.dadosRelatorio.reportVolume);
            EventBus.$emit('contratos-carregados', this.dadosRelatorio.totalContractsVolume);
        },
        async buscaCulturas() {
            await culturaService.findCultura().then(({ data }) => {
                const soja = data.find(cultura => cultura.nome.toLowerCase() === 'soja');
                if (soja) {
                    this.dadosRelatorio.culture = soja;
                }
                this.culturas = data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.dados-relatorio-rastreabilidade {
    margin-top: 15px;
}
.dados-relatorio-title {
    font-size: 16px;
    font-weight: 500;
}
.dados-relatorio-subtitle {
    font-size: 14px;
    font-weight: 400;
}
.dados-relatorio-form {
    width: 100%;
    background-color: var(--white);
    border-radius: 6px;
    padding: 15px;
}
.section-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: var(--primary-font-color);
}
.form-alignment {
    display: flex;

    .required {
        margin-left: 2px;
        color: var(--red)
    }
    .numero-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .volume {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .cultura {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .data-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
    }

    .custom-select-cultura {
        width: 100%;
    }
    .custom-date-picker {
        width: 100% !important;
    }
}

.is-invalid {
    border-color: var(--red);
}
.text-danger {
    color: var(--red);
    font-size: 12px;
}
</style>
